<div class="image-upload-container" [formGroup]="imageForm">
  <!-- Premium Drop Zone Area -->
  <div class="premium-drop-zone" *ngIf="!disabled">
    <div class="upload-icon-wrapper">
      <i class="pi pi-cloud-upload"></i>
    </div>
    <span class="upload-label">Browse {{ data?.label || 'File' | titlecase }}</span>
    <span class="upload-hint">Drag & drop or click to select</span>
    
    <input
      [attr.disabled]="disabled ? '' : null"
      (change)="handleFileInput($event)"
      [multiple]="data?.multiple || false"
      [accept]="(fileAccessType[data.fileType] || fileAccessType['FILE']).accessType"
      type="file"
      formControlName="pimage"
      class="custom-file-input"
    />
  </div>

  <!-- Success Feedback -->
  <div class="file-info-strip" *ngIf="!disabled && !fileInfos.progress && fileInfos?.fileName && fileInfos?.filePath">
    <i class="pi pi-check-circle"></i>
    <span class="file-name">{{ fileInfos.fileName }}</span>
  </div>

  <!-- Error Feedback -->
  <div class="error-message" *ngIf="!fileInfos.progress && fileStatusMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ fileStatusMessage }}</span>
  </div>

  <!-- Progress Bar -->
  <div *ngIf="fileInfos.progress" class="premium-progress">
    <div class="progress-bar" [style.width.%]="fileInfos.progress"></div>
  </div>

  <!-- Compact File Preview -->
  <div class="compact-preview-strip" *ngFor="let file of fileList; let i = index">
    <div class="file-thumb-container">
      <p-image *ngIf="checkIsImage(file.filePath)" 
           [src]="file.filePath" 
           [preview]="true"
           appendTo="body"
           imageClass="compact-img" 
           alt="Preview"></p-image>
      <div *ngIf="!checkIsImage(file.filePath)" class="doc-icon-wrapper">
        <i class="pi" [ngClass]="getFileIcon(file.filePath)"></i>
      </div>
    </div>
    
    <div class="file-meta">
      <span class="file-name-text">{{ file.fileName || 'Uploaded File' }}</span>
      <div class="file-actions">
        <a [href]="file.filePath" target="_blank" class="action-link" [attr.download]="!checkIsImage(file.filePath) ? '' : null">
          <i class="pi mr-1" [ngClass]="checkIsImage(file.filePath) ? 'pi-eye' : 'pi-download'"></i>
          {{ checkIsImage(file.filePath) ? 'View' : 'Download' }}
        </a>
        <ng-container *ngIf="!disabled">
          <span class="action-divider">|</span>
          <a (click)="resetFileInput(i)" class="action-link text-danger">
            <i class="pi pi-trash mr-1"></i>Remove
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
